// extracted by mini-css-extract-plugin
export default {"homeBackground":"Home_homeBackground__U1DB6","customerHome":"Home_customerHome__UQ89A","mobileNumber":"Home_mobileNumber__PyY+Z"};